import '@/design/index.less';
import 'ant-design-vue/dist/antd.css';
import 'echarts-gl';

import { createApp, reactive } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Antd from 'ant-design-vue';
import VueAxios from 'vue-axios';
// Import all icon libraries
import * as Icons from "@ant-design/icons-vue";
import type { Component } from 'vue'

const app = createApp(App)
const IconData: Record<string, Component> = Icons

Object.keys(IconData).forEach((key: string) => {
    app.component(key, IconData[key]);
})


import { dispatchEventStrage } from './common/watchLocalStorage'
app.use(dispatchEventStrage)

// Whether to validate the JWT token in iframes using sessionStorage
app.provide("useSessionJwtInIframe", true);

app.use(router).use(Antd).use(VueAxios, axios).mount('#app');
